<template>
  <div class="insights-ia-insight-content">
    <div class="container risk">
      <div class="title">
        <MaterialIcon icon="check_circle" size="16px" />
        <strong>Risco se não agir</strong>
      </div>

      <p class="risk-description">
        {{ contentWrapper.riskDescription }}
      </p>
    </div>

    <div v-if="contentWrapper.suggestedActions.length" class="container action">
      <div class="title">
        <MaterialIcon icon="check_circle" size="16px" cursor="pointer" />
        <strong>Ação sugerida</strong>
      </div>

      <ul>
        <li
          v-for="suggestedAction in contentWrapper.suggestedActions"
          :key="suggestedAction"
        >
          {{ suggestedAction }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
type TProps = {
  content: {
    summary: string;
    riskDescription: string;
    suggestedActions: string[];
  };
}
import MaterialIcon from '@/ui/components/Icons/MaterialIcon/MaterialIcon.vue'
import { ref } from 'vue'
const props = defineProps<TProps>();
const contentWrapper = ref({
  summary: props.content.summary,
  riskDescription: props.content.riskDescription,
  suggestedActions: props.content.suggestedActions
});
</script>

<style scoped lang="scss">
.insights-ia-insight-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 0 16px 16px;
  min-height: 52px;

  .title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;

    strong {
      font-size: 12px;
      line-height: 16px;
    }
  }

  .risk {
    gap: 8px;
    padding: 12px;
    border: 1px solid #ffb8b8;
    border-radius: 4px;
    background: #fff4f4;
    color: #9c2323;

    strong {
      display: block;
      font-size: 12px;
      line-height: 16px;
    }

    .risk-description {
      margin: 2px 0 0;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .action {
    padding: 12px;
    border: 1px solid #8de58d;
    border-radius: 4px;
    background: #eaffea;
    color: #1b6b2a;
  }

  ul {
    margin: 0;
    padding-left: 18px;
    color: #2e2e2e;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
